import { createEvent } from "$/util/db";
import { Download, FavoriteBorder, ModelTraining } from "@mui/icons-material";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import DownloadButton from "./DownloadButton";
import FavoriteButton from "./FavoriteButton";
import { useAuth } from "$/util/auth";

export default function CreationDetailToolbar(props) {
  const { item, variant, placeholder } = props;
  const navigate = useNavigate();
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const auth = useAuth();
  if (placeholder) {
    return (
      <Stack direction="row" spacing={mobileScreen ? 1 : 2} sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          color="inherit"
          disabled
          fullWidth
          size={mobileScreen ? "small" : "medium"}
          startIcon={<FavoriteBorder />}
        >
          Favorite
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          disabled
          fullWidth
          size={mobileScreen ? "small" : "medium"}
          startIcon={<ModelTraining />}
        >
          Remix
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          disabled
          fullWidth
          size={mobileScreen ? "small" : "medium"}
          sx={{ px: 2 }}
          startIcon={<Download />}
        >
          Download
        </Button>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={mobileScreen ? 1 : 2} sx={{ mt: 2 }}>
      {/*{(auth.isProUser || (auth.user && auth.user.credits < 0)) &&*/}
        <FavoriteButton
          creationId={item.id}
          idx={variant}
          full
          hideCount
          buttonProps={{ fullWidth: true, size: mobileScreen ? "small" : "medium" }}
        />
    {/*}*/}

      <Button
        variant="outlined"
        color="inherit"
        startIcon={<ModelTraining />}
        onClick={() => {
          createEvent("remix", item.id, variant);
          navigate("/", { state: { creationId: item.id, variant } });
        }}
        fullWidth
        size={mobileScreen ? "small" : "medium"}
      >
        Remix
      </Button>
      {/*{(auth.isProUser || (auth.user && auth.user.credits < 0)) &&*/}
        <DownloadButton
          creation={item}
          idx={variant}
          buttonProps={{
            fullWidth: true,
            size: mobileScreen ? "small" : "medium",
          }}
        />
    {/*}*/}
    </Stack>
  );
}
